import { render, staticRenderFns } from "./web-intro-page.vue?vue&type=template&id=f8956c82&scoped=true&"
import script from "./web-intro-page.vue?vue&type=script&lang=js&"
export * from "./web-intro-page.vue?vue&type=script&lang=js&"
import style0 from "./web-intro-page.vue?vue&type=style&index=0&id=f8956c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8956c82",
  null
  
)

export default component.exports